import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { DelIcon, EditIcon, PlusIcon, ProjectNameIcon, StatusCheckIcon } from 'assets';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GenericTable from 'shared/components/common/table/table';
import Heading from 'shared/components/common/heading/Heading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import AddBrand from 'shared/modal/add_brand/AddBrand';
import { DeleteBrandMutation, GetAllBrandQuery } from 'shared/services/brand_service/BrandService';
import DeleteConfirmation from 'shared/modal/delete_confirmation/DeleteConfirmation';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import SearchBar from 'shared/components/common/searchbar/SearchBar';
export default function Brand() {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const { isLoading: DelLoading, mutate: DelMutate, isSuccess } = DeleteBrandMutation();
    const navigate = useNavigate();
    const [milestoneOption, setMileStoneOption] = useState(false);
    const [openProduct, setOpenProduct] = useState(false);
    const [openDelConfirm, setOpenDelConfirm] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const closeProductHandler = () => setOpenProduct(false);
    const closeDelConfirmation = () => setOpenDelConfirm(false);
    const [searchMenu, setsearchMenu] = useState('');
    const [clicksearch, setClickSearch] = useState('')
    const [searchResults, setSearchResults] = useState([]);
    const obj = {}
    if (clicksearch) {
        obj['search'] = clicksearch
    }
    const allTaskQueryParams = new URLSearchParams(obj).toString();
    const { isLoading, data, isError, error } = GetAllBrandQuery(allTaskQueryParams);



    const SearchBars = () => {
        if (searchMenu.length > 0) {
            const filteredData = data.filter((user) => user.name.toLowerCase().includes(searchMenu.toLowerCase()));
            setSearchResults(filteredData);
        }
    }

    const [editBrandData, setEditBrandData] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const handleEditBrand = (brand) => {
        setEditBrandData(brand);
        setIsEditMode(true);
        setOpenProduct(true);
    };

    const handleCloseBrandModal = () => {
        setOpenProduct(false);
        setEditBrandData(null);
        setIsEditMode(false);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Brand
                    </div>
                ),
                accessor: 'name',
                Cell: ({ row }) => <div className="w-100">{row.original?.name}</div>
            },

            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100 text-end me-2`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Action
                    </div>
                ),
                accessor: 'status',
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-end align-items-center">
                        <div className="mx-2">
                            <EditIcon
                                className="pointer"
                                onClick={() => {
                                    handleEditBrand(row.original);
                                }}
                            />
                        </div>
                        <div className="mx-2">
                            <DelIcon
                                className="pointer"
                                onClick={() => {
                                    if (isRestrictActions(screenEnum.product, screenActionEnum.delete)) {
                                        setOpenDelConfirm(true);
                                        setSelectedItem(row.original);
                                    }
                                }}
                            />
                        </div>
                    </div>
                )
            }
        ],

        [theme, milestoneOption]
    );
    useEffect(() => {
        if (isSuccess) {
            setSelectedItem(null);
            closeDelConfirmation();
        }
        if (data) {
            setSearchResults(data);
        }
    }, [isSuccess, searchMenu, data]);
    return (
        <div className={classNames(styles.UserContainer, 'text-start')}>
            <SearchBar
                searchKey="name"
                suggestionsSource={data}
                onSearchChange={setSearchResults} // ✅ REQUIRED!
            />

            <div className={styles.Header}>
                <Heading heading={'Manage Brand'} headingStyle={styles.Heading} />
                <div className="d-flex">
                    <CustomButton
                        Icon={PlusIcon}
                        IconStyle={classNames('me-1', styles.IconStyle)}
                        text={'Add Brand'}
                        submitHandle={() => {
                            if (isRestrictActions(screenEnum.product, screenActionEnum.create)) {
                                setEditBrandData(null);
                                setIsEditMode(false);
                                setOpenProduct(true);
                            }
                        }}
                        containerStyle={classNames(styles.AddProduct)}
                    />
                </div>
            </div>
            <GenericTable columns={columns} data={searchResults || []} TDTextStyle={classNames(styles.TDTextStyle)} TableWrapperStyle={classNames(styles.Table)} />
            <AddBrand
                show={openProduct}
                datatable={data}
                isEdit={isEditMode}
                editData={editBrandData}
                handleClose={handleCloseBrandModal}
            />
            <DeleteConfirmation
                show={openDelConfirm}
                loading={DelLoading}
                ConfimationHeading="Delete Brand"
                Desc={'Are you sure you want to delete the brand?'}
                DeleteHandler={() => {
                    DelMutate(selectedItem?._id);
                }}
                handleClose={closeDelConfirmation}
            />
            {isLoading && <OverlayLoading />}
        </div>
    );
}
